import { Platform } from 'src/environment';
import { googleAnalytics } from './googleAnalytics';

export async function loadGoogleAnalytics() {
  if (window.ghsConfiguration.platform === Platform.WEB) {
    loadGoogleAnalyticsScript();
  }
}

function loadGoogleAnalyticsScript(): void {
  if (!window.gaInitialized) {
    window.gaInitialized = true;
    googleAnalytics(
      window,
      window.document,
      'script',
      'https://www.google-analytics.com/analytics.js',
      'ga',
    );
    const cookieDomain = /^(www|rc)/.test(window.location.host)
      ? window.location.host
      : 'auto';
    const {
      googleOptimizeContainerId,
      googleAnalyticsTrackingId,
      googleAnalyticsTrackerName,
    } = window.ghsConfiguration;

    window.ga('create', {
      trackingId: googleAnalyticsTrackingId,
      cookieDomain,
      name: googleAnalyticsTrackerName,
      allowLinker: true,
      useAmpClientId: true,
    });
    window.ga(
      `${googleAnalyticsTrackerName}.require`,
      googleOptimizeContainerId,
    );
    window.dataLayer.push({ event: 'optimize.activate' });
  }
}
